import { IButtonStyles, ISearchBoxStyles, IStyle, ITheme } from '@fluentui/react';
import { IContactUsCurrentTheme } from './theme.model';

export interface IGetHelpButtonStyles {
  theme: IContactUsCurrentTheme;
}

export const getHelpButtonStyles = (props: IGetHelpButtonStyles): IButtonStyles => {
  const { theme } = props;
  return {
    root: {
      selectors: {
        '@media screen and (-ms-high-contrast: active), screen and (forced-colors: active)': {
          color: 'window !important',
          backgroundColor: 'windowtext !important',
          borderColor: 'windowtext !important',
          forcedColorAdjust: 'none',
        },
      },
      border: '1px solid',
      borderColor: theme.semanticColors.primaryButtonBorder,
      borderRadius: '0',
      padding: '6px 12px',
      margin: '15px 0',
      minWidth: '0',
      textAlign: 'center',
      fontFamily: 'inherit',
    },
    rootDisabled: {
      selectors: {
        '@media screen and (-ms-high-contrast: active), screen and (forced-colors: active)': {
          color: 'graytext !important',
          backgroundColor: 'window !important',
          borderColor: 'graytext !important',
          forcedColorAdjust: 'none',
        },
      },
      borderColor: theme.semanticColors.primaryButtonBorder,
      pointerEvents: 'none',
      cursor: 'not-allowed',
      filter: 'alpha(opacity=65)',
      boxShadow: 'none',
      opacity: '.65',
    },
    rootHovered: {
      selectors: {
        '@media screen and (-ms-high-contrast: active), screen and (forced-colors: active)': {
          color: 'window !important',
          backgroundColor: 'highlight !important',
          borderColor: 'highlight !important',
        },
      },
      borderColor: theme.palette.themeDark,
    },
    rootFocused: {
      selectors: {
        '@media screen and (-ms-high-contrast: active), screen and (forced-colors: active)': {
          backgroundColor: 'windowtext !important',
        },
      },
      backgroundColor: `${theme.palette.themeDark} !important`,
      borderColor: `${theme.palette.blueDark} !important`,
      outline: '5px auto -webkit-focus-ring-color',
      outlineOffset: '-2px',
      textDecoration: 'none',
    },
    rootPressed: {
      selectors: {
        '@media screen and (-ms-high-contrast: active), screen and (forced-colors: active)': {
          backgroundColor: 'windowtext !important',
        },
      },
      borderColor: `${theme.palette.blueDark} !important`,
      outline: '5px auto -webkit-focus-ring-color',
      outlineOffset: '-2px',
      textDecoration: 'none',
    },
    label: {
      fontWeight: '400',
      fontSize: '14px',
    },
  };
};

export interface ISearchBoxStyleProps {
  theme: IContactUsCurrentTheme;
  isTeams: boolean;
  isSurfaceApp: boolean;
}

export const getSearchBoxStyles = (props: ISearchBoxStyleProps): ISearchBoxStyles => {
    const { theme, isTeams, isSurfaceApp } = props;
    const placeholderStyles: IStyle = isSurfaceApp ? {
      color: `${theme.semanticColors.inputPlaceholderText} !important`
    } : {};

    return {
        root: {
            boxShadow: isTeams ? '0 2px 4px rgb(0 0 0 / 10%)' : 'none',
            selectors: {
                '.ms-SearchBox': {
                    '&::after': {
                        border: isTeams && 'none',
                        borderBottom: isTeams && `2px solid ${theme.palette.themePrimary} !important`,
                    },
                },
                '.ms-SearchBox.ms-SearchBox--active': {
                    '&::after': {
                        border: isTeams && 'none !important',
                    },
                },
            },
        },
        icon: {
          color: `${theme.semanticColors.inputIcon} !important`,
        },
        field: {
          color: `${theme.palette.neutralPrimary} !important`,
          selectors: {
            '::placeholder': placeholderStyles,
            '::-webkit-input-placeholder': placeholderStyles,
            '::-moz-placeholder': placeholderStyles,
            ':-ms-input-placeholder': placeholderStyles,
            '::-ms-input-placeholder': placeholderStyles,
          }
        }
    };
};

export const getGetHelpSearchBoxStyle = (theme: ITheme): Partial<ISearchBoxStyles> => ({
  root: {
    borderRadius: '4px',
    borderBottomColor: theme.palette.neutralTertiary,
    paddingTop: '5px',
    paddingLeft: '11px',
    paddingRight: '11px',
    paddingBottom: '7px',
    selectors: {
      '&:hover': {
        borderBottomColor: theme.palette.neutralTertiary,
        textDecorationColor: theme.palette.neutralSecondary,
        backgroundColor: theme.semanticColors.bodyStandoutBackground,
      },
      '&:focus': {
        borderBottomColor: theme.palette.themeDarkAlt,
      },
      '&:rest:': {
        borderBottomColor: theme.palette.neutralTertiary,
      },
      '&:input:': {
        borderBottomColor: theme.palette.neutralTertiary,
      },
    },
    icon: {},
  },
});
